var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { InlineEdit } from '@components/v2/InlineEdit';
import { EditGenericEventModalContext } from '../../context/EditGenericEventModalContext';
function DefaultInformation() {
    const namespace = 'features.modals.edit_generic_event_modal.basic_information_section.default_information';
    const { handleModalSave } = useContext(EditGenericEventModalContext);
    const { control, getValues, trigger, formState: { errors } } = useFormContext();
    const handleBlur = (field, e) => __awaiter(this, void 0, void 0, function* () {
        const newValue = e.currentTarget.textContent || '';
        const oldValue = field.value;
        if (newValue === oldValue) {
            return;
        }
        field.onChange(newValue);
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Controller, { name: "title", control: control, rules: { required: translate('validations.title', { namespace }) }, render: ({ field }) => (React.createElement("div", { className: "info-container" },
                React.createElement("div", { className: "info-row" },
                    React.createElement("label", { className: "qmb-label--required info-key", htmlFor: field.name }, translate('event_title', { namespace })),
                    React.createElement(InlineEdit, { id: field.name, className: "info-value", variant: "x-full", placeholder: "", onBlur: (e) => handleBlur(field, e) }, field.value)),
                errors.title && React.createElement("div", { className: 'info-error' }, errors.title.message))) }),
        React.createElement(Controller, { name: "description", control: control, render: ({ field }) => (React.createElement("div", { className: "info-container" },
                React.createElement("div", { className: "info-row" },
                    React.createElement("label", { className: "qmb-label info-key", htmlFor: field.name }, translate('description', { namespace })),
                    React.createElement(InlineEdit, { id: field.name, className: "info-value", placeholder: "", variant: "x-full", onBlur: (e) => handleBlur(field, e) }, field.value)))) })));
}
export default DefaultInformation;
